import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SkillItem from './SkillItem'
import arraySort from 'array-sort'

const SkillsListContainer = styled.ul`
  border-top: 1px solid #bbbbbb;
  padding-bottom: 35px !important;
`

const SkillsList = ({ skills, dispatch, allowEdit }) => {
  const sortedSkills = arraySort(skills, 'name')

  const skillsList = sortedSkills.map(s => (
    <SkillItem
      key={s.skill_framework_id}
      skill={s}
      dispatch={dispatch}
      allowEdit={allowEdit}
    />
  ))

  return <SkillsListContainer>{skillsList}</SkillsListContainer>
}

SkillsList.propTypes = {
  skills: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool.isRequired
}

export default SkillsList



// WEBPACK FOOTER //
// ./src/components/quest/skills/SkillsList.js